import React from 'react';
import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  TableContainer,
  DialogActions
} from '@material-ui/core';
import numeral from 'numeral';
import { INVENTORY_TYPES } from 'src/constants';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { toDecimal4 } from 'src/utils/toDecimal';

function PhantomDetails({
  detail_items = [],
  open = false,
  invType = 0,
  onClose = () => null
}) {
  const { inv } = useSelector(state => state.bizMeta);
  const items = detail_items.map(item => ({
    ...item,
    total: toDecimal4(item.qty * item.price)
  }));

  const showBN = items.some(
    prod => inv?.BN?.required_categories ?? [].includes(prod?.ixCat ?? 0)
  );
  const showExpDate = showBN && Boolean(inv?.BN?.require_exp_date);
  const showProdDate = showBN && Boolean(inv?.BN?.require_prod_date);
  const total = items.reduce((acc, prev) => toDecimal4(acc + prev.total), 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h4" color="textSecondary">
          Items
        </Typography>
      </DialogTitle>

      <Divider />
      <DialogContent style={{ padding: 0 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Product</TableCell>
                <TableCell>Unit</TableCell>

                {showBN && <TableCell>{inv?.BN?.label ?? 'BN'}</TableCell>}
                {showProdDate && (
                  <TableCell>
                    {inv?.BN?.ProdDate_label ?? 'Prod. Date'}
                  </TableCell>
                )}
                {showExpDate && (
                  <TableCell>{inv?.BN?.ExpDate_label ?? 'Exp. Date'}</TableCell>
                )}

                {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE !== invType && (
                  <>
                    <TableCell>Qty</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Total</TableCell>
                  </>
                )}

                {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE === invType && (
                  <>
                    <TableCell>QTY IN</TableCell>
                    <TableCell>QTY OUT</TableCell>
                  </>
                )}
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan="100%">
                    <Typography
                      variant="h4"
                      align="center"
                      color="textSecondary"
                    >
                      No data to show!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}

              {items.map(item => (
                <TableRow key={item.ixTrans}>
                  <TableCell>{item.sProd}</TableCell>
                  <TableCell>{item.unit}</TableCell>

                  {showBN && <TableCell>{item.BN}</TableCell>}
                  {showProdDate && (
                    <TableCell>
                      {moment(item.ProdDate).format('MM/DD/YYYY')}
                    </TableCell>
                  )}
                  {showExpDate && (
                    <TableCell>
                      {moment(item.ExpDate).format('MM/DD/YYYY')}
                    </TableCell>
                  )}

                  {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE !== invType && (
                    <>
                      <TableCell align="right">
                        {numeral(item.qty).format('0,0.00')}
                      </TableCell>
                      <TableCell align="right">
                        {numeral(item.price).format('0,0.00')}
                      </TableCell>
                      <TableCell align="right">
                        {numeral(toDecimal4(item.total)).format('0,0.00')}
                      </TableCell>
                    </>
                  )}

                  {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE === invType && (
                    <>
                      <TableCell align="right">
                        {numeral(item.qtyIN).format('0,0.00')}
                      </TableCell>
                      <TableCell align="right">
                        {numeral(item.qtyOUT).format('0,0.00')}
                      </TableCell>
                    </>
                  )}

                  <TableCell>{item.remarks}</TableCell>
                </TableRow>
              ))}

              {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE !== invType && (
                <TableRow>
                  <TableCell />
                  <TableCell />

                  {showBN && <TableCell />}
                  {showProdDate && <TableCell />}
                  {showExpDate && <TableCell />}

                  {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE !== invType && (
                    <>
                      <TableCell />
                      <TableCell />
                      <TableCell
                        colSpan={5}
                        align="right"
                        style={{
                          fontWeight: 900
                        }}
                      >
                        {numeral(toDecimal4(total)).format('0,0.00')}
                      </TableCell>
                    </>
                  )}

                  {INVENTORY_TYPES.STOCK_ADJUSTMENT_BY_VARIANCE === invType && (
                    <>
                      <TableCell />
                      <TableCell />
                    </>
                  )}

                  <TableCell></TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PhantomDetails;
